import _ from 'underscore';
import templateStr from 'text!./stepper-select.html';
/* Creates an element accessor. Returns undefined if fnOrProp do not define a valid accessor. */
function accessor(fnOrProp) {
    if (_.isFunction(fnOrProp)) {
        return fnOrProp;
    }
    if (_.isString(fnOrProp)) {
        return _.property(fnOrProp);
    }

    return undefined;
}

function toString(obj) {
    return _.isNull(obj) || _.isUndefined(obj) ? '' : obj.toString();
}

/**
 * Stepper-based selection for the predefined list of values.
 * This one is strictly MVC-based. It ultimately respects a model value and have hooks for renderers, setters and
 * option value accessor.
 */

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {
            'model': '=gwPlStepperSelect',
            'options': '=',

            'selectBy': '=',
            'optionValue': '=',
            'renderBy': '='
        },

        controller: ['$scope', function ($scope) {
            var valueAccessor = accessor($scope.optionValue) || _.identity;
            var renderer = accessor($scope.renderBy) || toString;

            $scope.$watch('optionValue', function () {
                valueAccessor = accessor($scope.optionValue) || _.identity;
            });
            $scope.$watch('renderBy', function () {
                renderer = accessor($scope.renderBy) || toString;
            });

            function selectedIndex() {
                return _.findIndex($scope.options, function (mv) {
                    return valueAccessor(mv) === $scope.model;
                });
            }

            function couldGoPrev() {
                return $scope.options.length > 0 && $scope.model !== valueAccessor($scope.options[0]);
            }

            function couldGoNext() {
                var l = $scope.options.length;
                return l > 0 && $scope.model !== valueAccessor($scope.options[l - 1]);
            }

            function selectAt(idx) {
                if (idx < 0 || idx >= $scope.options.length) {
                    return;
                }
                var modelValue = valueAccessor($scope.options[idx]);
                if ($scope.selectBy) {
                    $scope.selectBy(modelValue);
                } else {
                    $scope.model = modelValue;
                }
            }

            $scope.couldGoPrev = couldGoPrev;
            $scope.couldGoNext = couldGoNext;
            $scope.displayValue = function () {
                var selIdx = selectedIndex();
                return selIdx < 0 ? '' : renderer($scope.options[selIdx]);
            };
            $scope.goBack = function () {
                var idx = selectedIndex();
                if (idx < 0) {
                    idx = $scope.options.length - 1;
                } else {
                    idx -= 1;
                }
                selectAt(idx);
            };
            $scope.goForward = function () {
                var idx = selectedIndex();
                if (idx < 0) {
                    idx = 0;
                } else {
                    idx += 1;
                }
                selectAt(idx);
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/stepper/StepperSelect.js
// module id = 786
// module chunks = 0